import { Checkbox } from '@nike/frame-component-library';
import {
  Default as _, match,
} from '@nike/rcf-fp';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import {
  getTenderTypeColumnWidth, isGreaterChinaGeo, isValidEmail, shouldShowCardNumberFilter
} from '../../utils/ej-utils';
import { Input, Select, DatePickerContainer } from '../reusable';

const tenderTypeOptions = [
  { label: '', value: undefined },
  { label: 'Credit', value: 'Credit' },
  { label: 'Debit', value: 'Debit' },
  { label: 'Gift Card', value: 'GiftCard' },
  { label: 'Cash', value: 'Cash' },
  { label: 'Complimentary', value: 'StoreAccount' },
  { label: 'Online Payment', value: 'OnlinePayment' }
];
const storedValueTenderTypeOptions = [
  { label: '', value: undefined },
  { label: 'Gift Card', value: 'GiftCard' },
];
const tenderTypesMYS = [
  ...tenderTypeOptions,
  { label: 'Mall Certificate', value: 'MallCertificate' },
];
const tenderTypeVoucher = [
  ...tenderTypeOptions,
  { label: 'Voucher', value: 'Voucher' },
];
const tenderTypeJPN = [
  ...tenderTypeOptions,
  { label: 'eMoney', value: 'ValueCertificate' },
];
const tenderTypeITA = [
  ...tenderTypeOptions,
  { label: 'Store Credit', value: 'Voucher' },
];
const tenderTypePromoVoucher = [
  ...tenderTypeOptions,
  { label: 'Promo Voucher', value: 'ValueCertificate' },
];
const tenderTypesMEX = [
  ...tenderTypeOptions,
  { label: 'Bank Transfer', value: 'WireTransfer' },
  { label: 'Store Credit', value: 'StoreCredit' },
  { label: 'Gift Certificate', value: 'GiftCertificate' },
];
const tenderTypesSGP = [
  ...tenderTypeOptions,
  { label: 'Mall Certificate', value: 'MallCertificate' },
];

const tenderTypeOptionsByCountry = (countryCode) => match(countryCode)(
  ['MYS', tenderTypesMYS],
  ['SGP', tenderTypesSGP],
  ['MEX', tenderTypesMEX],
  ['JPN', tenderTypeJPN],
  ['ITA', tenderTypeITA],
  [() => ['CHN', 'MAC', 'HKG'].includes(countryCode), tenderTypeVoucher],
  [() => ['AUT', 'BEL', 'CHE', 'DEU', 'FRA'].includes(countryCode), tenderTypePromoVoucher],
  [_, tenderTypeOptions]
);

const subTenderTypesCHN = [
{ label: 'All', value: 'All' },
{ label: 'AliPay', value: 'AliPay' },
{ label: 'WeChatPay', value: 'WeChatPay' },
{ label: 'TeleTransfer', value: 'TeleTransfer' }];

const storedTrainingModes = [
  { label: '', value: null },
  { label: 'Training', value: 'training' },
  { label: 'Non - Training', value: 'nonTraining' }
];

const CARD_NUMBER = 4;
const TransactionInformation = ({
 fields, today, handleChange, showNewUi, storeLocale
}) => {
  const { localizedBody } = useSelector((state) => state);
  const isGreaterChinaOnlinePayment = isGreaterChinaGeo(fields.selectedCountry?.value) && fields.tenderType === 'OnlinePayment';
    const showCardNumberFilter = shouldShowCardNumberFilter(fields.tenderType, storeLocale);

  return (
    <section className="ncss-col-sm-11 ncss-col-lg-10 border mb2-sm">
      <header className="ncss-row">
        <p className="headline-2 text-color-primary-light bg-black ta-sm-l pl2-sm">{ localizedBody.RL_TransactionInformation }</p>
      </header>
      <article className="ncss-row">
        <section className="ncss-col-sm-12 ncss-col-md-11 ncss-col-lg-10 ncss-col-xl-8 p4-sm ta-sm-l">
          {showNewUi
           ? (
             <Input
               label={localizedBody.RL_TransactionNo}
               type="number"
               value={fields.transactionNumber}
               onChange={(value) => handleChange('transactionNumber', value)}
             />
            ) : (
              <article className="ncss-col-sm-12 ncss-col-md-6">
                <p className="body-2 mt2-sm">{localizedBody.RL_DateRange}</p>
                <DatePickerContainer
                  enableOutsideDays
                  enableRange
                  enableTime
                  className="ta-sm-c u-cursor-pointer ncss-input"
                  latestDateTime={today}
                  placeholder="Click To Select A Date"
                  selectedDates={fields.selectedDates}
                  onClickOff={(value) => handleChange('selectedDates', value)}
                />
              </article>
          )}
          {showNewUi
            ? (<article className="ncss-col-sm-12 ncss-col-md-6" />)
          : (
            <Input
              label={localizedBody.RL_TransactionNo}
              type="number"
              value={fields.transactionNumber}
              onChange={(value) => handleChange('transactionNumber', value)}
            />
          )}
          <Input
            label={localizedBody.RegisterNumber}
            value={fields.registerNumber}
            onChange={(value) => handleChange('registerNumber', value)}
          />
          <Input
            label={localizedBody.RL_AthleteLoginNumber}
            value={fields.athleteLoginNumber}
            onChange={(value) => handleChange('athleteLoginNumber', value)}
          />
          {fields.transactionType !== 'NoSale' && (
          <>
            <section className="ncss-col-sm-12 ncss-col-md-6 va-sm-t">
              <p className="body-2 mt2-sm mb-2-sm">{localizedBody.RL_AmountRange}</p>
              <section className="ncss-row">
                <Input
                  className="ncss-col-sm-6"
                  placeholder={localizedBody.RL_EnterMin}
                  type="number"
                  value={fields.minimumAmount}
                  onChange={(value) => handleChange('minimumAmount', value)}
                />
                <Input
                  className="ncss-col-sm-6"
                  placeholder={localizedBody.RL_EnterMax}
                  type="number"
                  value={fields.maximumAmount}
                  onChange={(value) => handleChange('maximumAmount', value)}
                />
              </section>
              {(fields.minimumAmount && fields.maximumAmount && Number(fields.minimumAmount) >= Number(fields.maximumAmount)) && (
                <p className="text-color-error body-4 mt1-sm">Min Amount must be less than the Max Amount.</p>
              )}
              {/* This is a logical XOR on these two fields */}
              {(fields.minimumAmount ? !fields.maximumAmount : fields.maximumAmount) && (
                <p className="text-color-error body-4 mt1-sm">Both Min Amount and Max Amount are required.</p>
              )}
            </section>
            {showNewUi
            ? (<article className="ncss-col-sm-12 ncss-col-md-6 va-sm-t" />)
            : (
              <article className="ncss-col-sm-12 ncss-col-md-6 va-sm-t">
                <section className="ncss-row">
                  <Select
                    className={`ncss-col-sm-${getTenderTypeColumnWidth(fields.tenderType, isGreaterChinaOnlinePayment, storeLocale)} va-sm-t`}
                    label={localizedBody.RL_TenderType}
                    options={fields.transactionType === 'StoredValueTransaction' ? storedValueTenderTypeOptions : tenderTypeOptionsByCountry(fields.selectedCountry?.value)}
                    value={fields.tenderType}
                    zIndex={5}
                    onChange={(value) => handleChange('tenderType', value)}
                  />
                  {isGreaterChinaOnlinePayment && (
                  <Select
                    className="ncss-col-sm-6 va-sm-t"
                    label={localizedBody.RL_SubTenderType}
                    options={subTenderTypesCHN}
                    value={fields.subTenderType}
                    zIndex={5}
                    onChange={(value) => handleChange('subTenderType', value)}
                  />
                )}
                  {showCardNumberFilter && (
                  <Input
                    className="ncss-col-sm-6 va-sm-t"
                    errorMessage={fields.cardNumber.length >= 1 && fields.cardNumber.length !== CARD_NUMBER ? 'Card Number must be 4 digits.' : ''}
                    label="Card Number"
                    placeholder={localizedBody.RL_ErrCardNoDigits}
                    type="number"
                    value={fields.cardNumber}
                    onChange={(value) => handleChange('cardNumber', value)}
                  />
                )}
                </section>
              </article>
            )}
          </>
          )}
          {(fields.transactionType === 'RetailTransaction' || fields.transactionType === 'Return') && (
          <>
            <Input
              label={localizedBody.OrderId}
              value={fields.orderId}
              onChange={(value) => handleChange('orderId', value)}
            />
            <Input
              errorMessage={!isValidEmail(fields.billToEmail) ? 'Enter a valid email id' : ''}
              label={localizedBody.RL_ContactEmailID}
              type="email"
              value={fields.billToEmail}
              onChange={(value) => handleChange('billToEmail', value)}
            />
            {showNewUi ? (
              <article className="ncss-col-sm-12 ncss-col-md-6 va-sm-t" />
            ) : (
              <section className="ncss-col-sm-12 ncss-col-md-6 va-sm-t">
                <section className="ncss-row">
                  <Input
                    className="ncss-col-sm-12"
                    label={localizedBody.RL_UPCcode}
                    value={fields.upcCode}
                    onChange={(value) => handleChange('upcCode', value)}
                  />
                </section>
              </section>
  )}
            <section className="ncss-col-sm-12 ncss-col-md-6 va-sm-t">
              <section className="ncss-row">
                <Select
                  className="ncss-col-sm-12 va-sm-t"
                  label={localizedBody.RL_TRAININGMODE}
                  options={storedTrainingModes}
                  value={fields.trainingMode}
                  zIndex={4}
                  onChange={(value) => handleChange('trainingMode', value)}
                />
              </section>
            </section>
            <section className="ncss-col-sm-12 ncss-col-md-6 va-sm-t">
              <section className="ncss-row">
                <Input
                  className="ncss-col-sm-12"
                  label={localizedBody.RL_OriginalTransactionNumber}
                  value={fields.originalTransactionNumber}
                  onChange={(value) => handleChange('originalTransactionNumber', value)}
                />
              </section>
            </section>
            <section className="ncss-col-sm-6 ncss-col-md-3 va-sm-t">
              <p className="body-2 mt2-sm">{localizedBody.RL_Modifiers}</p>
              <Checkbox
                isChecked={fields.generalDiscount}
                label={localizedBody.RL_GeneralDiscount}
                onChange={({ target: { checked } }) => handleChange('generalDiscount', checked)}
              />
              <Checkbox
                isChecked={fields.employeeDiscount}
                label={localizedBody.RL_EmployeeDiscount}
                onChange={({ target: { checked } }) => handleChange('employeeDiscount', checked)}
              />
              <Checkbox
                isChecked={fields.priceOverride}
                label={localizedBody.RL_PriceOverride}
                onChange={({ target: { checked } }) => handleChange('priceOverride', checked)}
              />
              <Checkbox
                isChecked={fields.promotion}
                label={localizedBody.RL_Promotion}
                onChange={({ target: { checked } }) => handleChange('promotion', checked)}
              />
            </section>
            <section className="ncss-col-sm-6 ncss-col-md-3 va-sm-t">
              <p className="body-2 mt2-sm">{localizedBody.RL_Status}</p>
              <Checkbox
                isChecked={fields.void}
                label={localizedBody.RL_Void}
                onChange={({ target: { checked } }) => handleChange('void', checked)}
              />
              <Checkbox
                isChecked={fields.resume}
                label={localizedBody.RL_Resume}
                onChange={({ target: { checked } }) => handleChange('resume', checked)}
              />
              <Checkbox
                isChecked={fields.suspend}
                label={localizedBody.RL_Suspend}
                onChange={({ target: { checked } }) => handleChange('suspend', checked)}
              />
              <Checkbox
                isChecked={fields.delivered}
                label={localizedBody.RL_Delivered}
                onChange={({ target: { checked } }) => handleChange('delivered', checked)}
              />
            </section>
            <section className="ncss-col-sm-12 ncss-col-md-6 va-sm-t" style={{ marginBottom: '-70px', position: 'relative', top: '-70px' }}>
              <section className="ncss-row">
                <Input
                  className="ncss-col-sm-12"
                  label={localizedBody.RL_Till}
                  value={fields.tillId}
                  onChange={(value) => handleChange('tillId', value)}
                />
              </section>
            </section>
          </>
          )}
          {(fields.transactionType === 'NoSale' || fields.transactionType === 'StoredValueTransaction') && (
            <>
              <Input
                label={localizedBody.RL_Till}
                value={fields.tillId}
                onChange={(value) => handleChange('tillId', value)}
              />
            </>
            )}
        </section>
      </article>
    </section>
  );
};

TransactionInformation.propTypes = {
  fields: PropTypes.shape().isRequired,
  handleChange: PropTypes.func.isRequired,
  showNewUi: PropTypes.bool.isRequired,
  storeLocale: PropTypes.string.isRequired,
  today: PropTypes.shape().isRequired,
};

export default TransactionInformation;
